"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongText = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@jobmatchme/ui/es/components/TextField"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _Optimizers = require("../../utils/Optimizers");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Funnel long textfield component.
 **/
var LongTextComponent = function LongTextComponent(_ref) {
  var _config$educationTool;

  var config = _ref.config,
      context = _ref.context;
  var minTextLength = 5; // Chars

  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue,
      getDefault = _useContext.getDefault;

  var valueType = config.valueType,
      valueName = config.valueName,
      identifier = config.identifier,
      generatedText = config.generatedText;
  var visibleFor = config.educationTooltip && config.educationTooltip.visibleFor;

  var handleChange = function handleChange(event) {
    if (event.target.value && event.target.value.length > minTextLength) {
      if (valueType === 'String') setValue(valueName, event.target.value);
      if (valueType === 'DescriptionString') setValue(config.valueName, {
        identifier: identifier,
        text: event.target.value || undefined
      });
    }
  };

  var defaultValue = (0, _react.useCallback)(function () {
    var discriminator = context.discriminator;
    var currentOrDefault = valueType === 'DescriptionString' ? context[valueName].value[identifier] : context[valueName].value;

    if (generatedText && discriminator) {
      return t(config.translations[discriminator]) + getDefault(valueName, identifier, generatedText, context);
    }

    if (!currentOrDefault) {
      return getDefault(valueName, identifier);
    }

    return currentOrDefault;
  }, [t, context, valueType, valueName, identifier, generatedText, config.translations, getDefault]);

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      defaultText = _useState2[0],
      setDefaultText = _useState2[1];

  (0, _react.useEffect)(function () {
    setDefaultText(defaultValue());
  }, [defaultValue]);
  (0, _react.useEffect)(function () {
    if (generatedText) {
      if (defaultText) {
        setValue(config.valueName, {
          identifier: identifier,
          text: defaultText || undefined
        });
      }
    }
  }, [config.valueName, defaultText, generatedText, identifier, setValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.LongText,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      toolTipVisible: visibleFor,
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat((0, _Onboarding.targetClassName)((_config$educationTool = config.educationTooltip) === null || _config$educationTool === void 0 ? void 0 : _config$educationTool.target)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _styleModule.default.fieldWrapper,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          className: _styleModule.default.TextField,
          name: config.valueName,
          defaultValue: defaultText,
          onBlur: handleChange,
          onChange: handleChange,
          placeholder: t(config.translations.inputField) ? t(config.translations.inputField) : defaultValue,
          rows: 6,
          multiline: true,
          fullWidth: true,
          noBorder: true,
          defaultInput: true
        })
      })
    })]
  });
};

var LongTextWrapper = (0, _Optimizers.memoizeComponentByValue)(LongTextComponent);

var LongText = function LongText(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(LongTextWrapper, {
    config: config,
    context: context
  });
};

exports.LongText = LongText;